import React from "react";
import ReactDOM from "react-dom";

export default class PortView extends React.Component {
    /**
     * Port view to handle mouse events for ports
     * @module PortView
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
        this.portWrapper = null;
    }

    /**
     * Get reference to port itself
     * @returns {jQuery}
     */
    getDomSelf(){
        return $(ReactDOM.findDOMNode(this));
    }

    /**
     * Improve performance by disabling re-render of this component
     * This component does not need to be re-rendered since it does not render on data model changes
     * @param nextProps (Unused)
     * @param nextState (Unused)
     * @returns {boolean}
     */
    shouldComponentUpdate(nextProps, nextState) {
        return false;
    }

    componentDidMount(){
        this.portWrapper = this.getDomSelf().find('.port-highlight-wrapper');
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        return (
            <div
                onMouseEnter={event => {
                    this.portWrapper.show();
                }}
                onMouseLeave={event => {
                    this.portWrapper.hide();
                }}
            >
                <div className="port-highlight-wrapper"/>
                <div className="port-decoration"/>
                <div
                    className={"port"}
                    data-name={this.props.model.name}
                    data-nodeid={this.props.model.getParent().getID()}
                />
            </div>
        );
    }
}